import { mainUrl, client } from '../app-constants';

export function getPianoTechCustomerList() {
    const url = mainUrl + 'pt.cust/listPianoTechCustomer'

    return client.get(url);
}

export function getPianoTechCustomerListByCompany(companyId) {
    const url = mainUrl + 'pt.cust/listByCompanyId?companyId=' + companyId;

    return client.get(url);
}

export function findPianoTechCustomer(customerId) {
    const url = mainUrl + 'pt.cust/findPianoTechCustomer?customerId=' + customerId;

    return client.get(url);
}

export function savePianoTechCustomer(pianoTechCustomer) {
    const url = mainUrl + 'pt.cust/savePianoTechCustomer';

    return client.post(url, pianoTechCustomer);
}

